import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { useLocalizedHref } from "@/hooks/useLocalizedHref";

interface Stat {
  num: string;
  label: string;
  href?: string;
}

export function StatsStrip() {
  const { t } = useTranslation();
  const localizedHref = useLocalizedHref();
  const stats = t("landing.statsStrip.items", { returnObjects: true }) as Stat[];

  return (
    <div className="mt-10 hidden rounded-[18px] border border-line bg-surface sm:block">
      <div className="flex flex-wrap items-stretch justify-center px-5 py-8 sm:px-7 sm:py-10">
        {stats.map((s, i) => {
          const inner = (
            <>
              <span className="relative inline-block text-[clamp(40px,4.6vw,60px)] leading-none font-semibold tracking-[-0.04em] text-ink">
                {s.num}
                <span
                  aria-hidden="true"
                  className="absolute -bottom-1.5 left-1/2 h-px w-6 -translate-x-1/2 bg-accent"
                />
              </span>
              <span className="mt-[18px] max-w-[18ch] text-[13px] leading-snug text-ink-2/85 sm:text-[14px]">
                {s.label}
              </span>
            </>
          );
          const cellClass = cn(
            "relative flex-1 min-w-[140px] basis-[140px] px-5 sm:px-7 flex flex-col items-center text-center",
            i > 0 &&
              "before:hidden md:before:block before:absolute before:left-0 before:top-3 before:bottom-3 before:w-px before:bg-ink/15",
          );
          if (!s.href) {
            return (
              <div key={s.label} className={cellClass}>
                {inner}
              </div>
            );
          }
          const [path, hash] = s.href.split("#");
          return (
            <Link
              key={s.label}
              to={localizedHref(path ?? s.href)}
              hash={hash}
              className={cn(cellClass, "group transition-opacity hover:opacity-80")}
            >
              {inner}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
